export var handleOnlyNumbers = function handleOnlyNumbers(event) {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};
export var filename = function filename(urlList) {
  return urlList[urlList.length - 1];
};